import React from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'
import { dateToBR } from 'utils/date'
import DescItemInfo from 'ui-components/DescItemInfo/DescItemInfo'
import { Checkbox } from 'ui-components/Checkbox'
import { Pending } from './styles'

export default function Orders(props) {
  const {
    orders,
    selectedOrders,
    onSelect,
    onDeselect,
  } = props

  const wasSelected = (id) => {
    const selected = selectedOrders.filter((item) => Number(item.id) === Number(id))
    return Boolean(selected.length)
  }

  const handleCheckboxClick = (order) => (event) => {
    const { checked } = event.target

    if (checked) return onSelect(order)
    return onDeselect(order)
  }

  const renderOrder = (order) => (
    <Pending key={`order-${order.id}`}>
      <DescItemInfo label="">
        <Checkbox
          checked={wasSelected(order.id)}
          color="primary"
          onChange={handleCheckboxClick(order)}
        />
      </DescItemInfo>

      <DescItemInfo label="Data">
        {dateToBR(order.attributes.date)}
      </DescItemInfo>

      <DescItemInfo label="Número">
        {order.attributes.code}
      </DescItemInfo>

      <DescItemInfo label="Valor R$">
        {currencyFormat(order.attributes.value)}
      </DescItemInfo>
    </Pending>
  )

  return !orders.length ? null : (
    <div>
      <h4>Lista de pedidos pendentes</h4>
      { orders.map(renderOrder) }
    </div>
  )
}

Orders.propTypes = {
  orders: PropTypes.arrayOf(PropTypes.object),
  selectedOrders: PropTypes.arrayOf(PropTypes.object),
  onSelect: PropTypes.func.isRequired,
  onDeselect: PropTypes.func.isRequired,
}

Orders.defaultProps = {
  orders: [],
  selectedOrders: [],
}
